import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import { generateReferenceLocation } from './urlUtils';
export var buildReferencing = function buildReferencing(list) {
  return list.map(function (item) {
    var citations = !item.contents ? null : item.contents.map(function (content) {
      var sentence = prepareBody(content.content, content.linkText);
      return {
        key: content.key,
        series: content.series,
        label: content.label,
        sentence: sentence
      };
    });
    return {
      docId: item.id,
      title: item.title,
      citations: citations,
      packs: item.packs
    };
  });
};

// TODO: htmlをparseしていい感じの文字列長で切る
// TODO: TextContentの複数ヶ所にlinkがある場合(=linkがContentLink[]になる場合)
export var prepareBody = function prepareBody(body, linkText) {
  var replacer = function replacer(str, textInA) {
    return linkText === textInA ? "<b>".concat(textInA, "</b>") : textInA;
  };
  return body.replace(/<a.*?>(.*?)<\/a>/gi, replacer);
};
export var useCitation = function useCitation(reference, option) {
  var fetchedKey = ref('');
  var list = ref([]);
  watchEffect(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    var _option$prevent, _option$beforeFetch, _option$afterFetch;
    var fetchKey;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (!((_option$prevent = option.prevent) !== null && _option$prevent !== void 0 && _option$prevent.value)) {
            _context.next = 2;
            break;
          }
          return _context.abrupt("return");
        case 2:
          if (reference.value.documentId && reference.value.sectionKeys && reference.value.sectionKeys.length) {
            _context.next = 4;
            break;
          }
          return _context.abrupt("return");
        case 4:
          fetchKey = "".concat(reference.value.documentId, "-").concat(reference.value.sectionKeys.join('-'));
          if (!(fetchKey === fetchedKey.value)) {
            _context.next = 7;
            break;
          }
          return _context.abrupt("return");
        case 7:
          fetchedKey.value = fetchKey;
          (_option$beforeFetch = option.beforeFetch) === null || _option$beforeFetch === void 0 ? void 0 : _option$beforeFetch.call(option);
          _context.next = 11;
          return option.fetcher(reference.value.documentId, reference.value.sectionKeys);
        case 11:
          list.value = _context.sent;
          (_option$afterFetch = option.afterFetch) === null || _option$afterFetch === void 0 ? void 0 : _option$afterFetch.call(option);
        case 13:
        case "end":
          return _context.stop();
      }
    }, _callee);
  })));
  return {
    list: list
  };
};
export var showInCitationPanelGenerator = function showInCitationPanelGenerator(router) {
  return function (reference, citation) {
    router.push(generateReferenceLocation(location.href, {
      reference_doc: reference.docId,
      reference_key: String(citation.key),
      reference_series: String(citation.series)
    }));
  };
};